import { SizeCodeForListing } from 'entities/SizeCode';

export const checkIsRateChanged = (sizeCode: SizeCodeForListing, updatedSizeCode: SizeCodeForListing): boolean => {
  return (
    sizeCode.dailyRate !== updatedSizeCode.dailyRate ||
    sizeCode.weekRate !== updatedSizeCode.weekRate ||
    sizeCode.monthRate !== updatedSizeCode.monthRate
  );
};
